import { render, staticRenderFns } from "./AddAttachmentCentre.vue?vue&type=template&id=9a90fd94&scoped=true"
import script from "./AddAttachmentCentre.vue?vue&type=script&lang=js"
export * from "./AddAttachmentCentre.vue?vue&type=script&lang=js"
import style0 from "./AddAttachmentCentre.vue?vue&type=style&index=0&id=9a90fd94&prod&lang=css"
import style1 from "./AddAttachmentCentre.vue?vue&type=style&index=1&id=9a90fd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a90fd94",
  null
  
)

export default component.exports